import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createInternship } from "store/slices/internshipsSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import InternshipForm from "./internship-form";

const NewInternshipModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.internships);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "new_internship";

  const { userData } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (open) {
      if (userData?._id) dispatch(getSchools(userData?._id));
    }
  }, [dispatch, open, userData?._id]);

  const onSubmit = async (values) => {
    if (values?.startingDate) {
      values.startingDate = dayjs(values?.startingDate)?.format("YYYY-MM-DD");
    }

    return await dispatch(createInternship(values))?.unwrap()?.then(() => {
        notification?.success({
          message: t("common.success"),
          description: t("internships.notif.createdSuccess"),
        });
        onClose();
      })?.catch((error) => {
        notification?.error({
          message: t("common.error"),
          description: error?.message,
        });
      });
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>{t("internships.crud.new")}</h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="internship_form"
          disabled={loading}
        >
          {t("common.create")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <InternshipForm form={form} schools={schools} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewInternshipModal;
